<template>
	<div class="basic_wrap">
		<bsHeader :title="$t('goods.myPoint') + user.point" @backurl="$router.back()"></bsHeader>
		<div class="goods_wrap">
			<div class="img">
				<img :src="goods.img" alt="" srcset="">
			</div>
			<div class="block_div detail">
				<div class="price">
					<span class="point">{{ goods.point }}</span>
					<span class="point_tips">{{ $t('goods.point') }}</span>
				</div>
				<div class="title">
					{{ goods.title }}
				</div>
			</div>
			<div class="block_div content" v-html="goods.content">

			</div>
		</div>
		<div class="basic_btn sbtn" @click="sureSubmit" style="width: 100%; ">
			{{ $t('goods.exchange') }}
		</div>

		<!-- 绑定收货地址 -->
		<van-popup class="loginModel" v-model="showBindUserInfo" closeable round :style="{ width: '90%' }">

			<div class="phoneLogin">
				<div class="title">{{ $t('收货人信息') }}</div>

				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="addressParam.consignee"
						:placeholder="$t('收货人')" />
				</div>
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="addressParam.mobile"
						:placeholder="$t('联系手机')" />
				</div>
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="addressParam.address"
						:placeholder="$t('地址')" />
				</div>
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="addressParam.email"
						:placeholder="$t('邮箱')" />
				</div>
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="addressParam.postcode"
						:placeholder="$t('邮编')" />
				</div>

				<!-- 绑定按钮 -->
				<div class="bindBtnBox">
					<van-button class="bindBtn" type="primary" @click="addaddress()" block>{{
						$t('确定') }}</van-button>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import {
	Dialog
} from 'vant';
export default {
	name: "goodsDetail",
	components: {
		bsHeader
	},
	data() {
		return {
			goods: [],
			user: {
				point: 0,
			},
			loading: false,
			showBindUserInfo: false,
			addressParam: {
				log_id: '',
				consignee: '',
				mobile: '',
				address: '',
				email: '',
				postcode: ''
			}
		};
	},
	created() {
		if (window.plus) {
			plus.navigator.setStatusBarBackground('#FFFFFF');
			plus.navigator.setStatusBarStyle('dark');
		}
		this.$parent.footer('user', false);
	},
	mounted() {
		this.start();
	},
	methods: {
		addaddress() {
			if (this.addressParam.log_id == '' || this.addressParam.consignee == '' || this.addressParam.mobile == '' || this.addressParam.address == '' || this.addressParam.email == '' || this.addressParam.postcode == '') {
				this.$toast(this.$t('请输入完整的信息'));
				return;
			}
			Fetch('/user/addaddress', {
				...this.addressParam,
			}).then(r => {
				// this.showChangePass = false;
				// // this.params1.oldpassword = '';
				// this.paramsTiKuanPass.password = '';
				// this.paramsTiKuanPass.oldpassword = '';
				// this.$router.replace('/user');
				this.showBindUserInfo = false;
				this.$toast(this.$t('收货地址提交成功'));

				setTimeout(() => {
					this.$router.replace('/goods/record');
				}, 3000);
			})

		},
		start() {
			Fetch('/index/goods_detail', {
				id: this.$router.history.current.params.code
			}).then(r => {
				this.goods = r.data.goods;
				this.user = r.data.user;
			})
		},

		sureSubmit() {
			Dialog.confirm({
				title: this.$t('温馨提示'),
				confirmButtonText:this.$t('utils.confirm'),
				cancelButtonText:this.$t('utils.cancel'),
				message: this.$t('兑换')+this.goods.title+this.$t('需要')+this.goods.point+this.$t('积分')+','+this.$t('是否确定兑换?'),
			})
				.then(() => {
					this.submit();
				})
				.catch(() => {
					// on cancel
				});
		},

		submit() {

			if (this.loading) return false;
			if (this.user.point < this.goods.point) {
				this.$toast(this.$t('draw.pointsEmpty'));
				return false;
			}
			this.loading = true;
			this.user.point = this.user.point - this.goods.point;
			Fetch('/user/goods_exchange', {
				id: this.goods.id
			}).then(r => {
				console.log('1111111111', r);
				if (r.data.type == 1) {
					this.showBindUserInfo = true;
					this.addressParam.log_id = r.data.log_id;
					this.$toast(this.$t('兑换成功，请填写收货地址'));
				} else {
					this.$toast(this.$t('login.goodsExchangeSuccess'));
					setTimeout(() => {
						this.$router.replace('/goods/record');
					}, 3000);
				}



			})
		}
	}
};
</script>

<style lang="less" scoped>
.basic_wrap {
	min-height: 100vh;
}

.loginModel {
	background: white;
	box-sizing: border-box;
	text-align: center;
	color: #ffffff;
	-webkit-border-radius: 10px;
	-moz-border-radius: 10px;
	border-radius: 10px;
	padding: 0 28px;
	padding-top: 42px;
	padding-bottom: 28px;
}

.phoneLogin {
	.title {
		color: #0A0A27;
		font-weight: bold;
		font-size: 18px;
		text-align: center;
	}

	.phoneInputBox {
		.phoneInput {
			width: 100%;
			border-radius: 4px;
			background: none;
			background: #F5F6F8;
			height: 60px;
			border: 0px;
			line-height: 60px;
			padding-left: 16px;
			outline: none;
			margin-top: 20px;
			font-size: 14px;
			color: #0A0A27;
		}

		input::placeholder {
			font-weight: bold;
			opacity: 0.5;
			color: #333;
		}
	}


	.codeBox {
		display: flex;
		justify-content: space-between;
		margin-top: 20px;

		.codeInput {
			border-radius: 4px;
			background: none;
			background: #F5F6F8;
			height: 60px;
			border: 0px;
			line-height: 60px;
			padding-left: 16px;
			outline: none;
			font-size: 14px;
			color: #0A0A27;
			width: 100%;

			::-webkit-input-placeholder {
				color: #333333;
				font-size: 12px;
			}
		}

		.pic1 {
			margin-left: 8px;
			width: 130px;
		}

	}

	.bindBtnBox {
		max-width: 750px;

		.bindBtn {
			height: 38px;
			border-radius: 100px;
			margin-top: 44px;
			border-radius: 4px;
			background: #326CF6;

			.van-button__text {
				font-size: 14px;
				font-weight: 400;
				color: white;
			}
		}
	}

	.input_box_email {
		margin-top: 20px;

		.input_send_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			height: 60px;
			background: #F5F6F8;
			margin-top: 15px;
			border-radius: 8px;


			.input_main {
				width: 100%;
				border-radius: 4px;
				background: none;
				height: 60px;
				border: 0px;
				line-height: 60px;
				padding-left: 16px;
				outline: none;
				font-size: 14px;
				color: #0A0A27;
			}

			input::placeholder {
				font-weight: bold;
				opacity: 0.5;
				color: #333;
			}


			.input_send {
				height: 100%;
				width: 150px;
				display: flex;
				justify-content: center;
				align-items: center;
				background-color: #326CF6;
				border-radius: 0 8px 8px 0;
				color: white;
				font-size: 12px;
			}


		}

	}


	.btn {
		position: inherit;
	}
}

.goods_wrap {
	margin-top: 54px;
	padding-bottom: 60px;
	background: white;

	.img {
		img {
			width: 100%;
		}
	}

	.detail {
		padding: 20px;
		margin: 10px 0 10px 0;
		width: 100%;

		.point {
			font-size: 18px;
			font-weight: bold;
			color: #FF0000;
		}

		.point_tips {
			margin-left: 5px;
		}

		.title {
			margin-top: 15px;
			line-height: 2;
			font-weight: bold;
		}
	}

	.content {
		margin: 10px 0 10px 0;
		width: 100%;
		// padding: 20px;
		line-height: 2;
		padding: 0 16px;
	}
}

.sbtn {
	position: fixed;
	bottom: 20px;
	background: #f24d0c;
	max-width: 750px;
	margin: 0 auto;
}
</style>
